export { AnchoredImage } from './AnchoredImage';
export type { AnchoredImageProps, ImageAnchor } from './AnchoredImage';
